/**
 * 权限相关工具函数
 *
 * 使用示例:
 * const permissions = getCurrentButtonPermissions('/user/list');
 * const buttonPermissions = formatButtonPermissions(permissions);
 * // 结果: { add: true, edit: true, delete: true, export: true }
 */

/**
 * 递归查找路由对应的按钮权限
 * @param {Array} routerList - 路由列表
 * @param {string} targetPath - 目标路径
 * @returns {Array} 返回type=3的按钮权限列表
 */
export function findButtonPermissions(routerList, targetPath) {
  if (!routerList || !Array.isArray(routerList)) {
    return [];
  }

  for (let item of routerList) {
    // 检查当前节点的path是否匹配
    if (item.path === targetPath || item.pathname === targetPath) {
      // 查找children中type=3的按钮权限
      if (item.children && Array.isArray(item.children)) {
        return item.children.filter((child) => child.type === "3");
      }
      return [];
    }

    // 递归查找子节点
    if (item.children && Array.isArray(item.children)) {
      const result = findButtonPermissions(item.children, targetPath);
      if (result.length > 0) {
        return result;
      }
    }

    // 如果有childrenMenuList属性，也要递归查找
    if (item.childrenMenuList && Array.isArray(item.childrenMenuList)) {
      const result = findButtonPermissions(item.childrenMenuList, targetPath);
      if (result.length > 0) {
        return result;
      }
    }
  }

  return [];
}

/**
 * 获取当前路径的按钮权限
 * @param {string} currentPath - 当前路径
 * @returns {Array} 按钮权限列表
 */
export function getCurrentButtonPermissions(currentPath) {
  try {
    const routerList = JSON.parse(sessionStorage.getItem("routerListPermission") || "[]");
    return findButtonPermissions(routerList, currentPath);
  } catch (error) {
    console.error("获取按钮权限失败:", error);
    return [];
  }
}

/**
 * 格式化按钮权限数据，提取关键信息
 * @param {Array} permissions - 原始权限数据
 * @returns {Object} 格式化后的权限数据对象
 */
export function formatButtonPermissions(permissions) {
  if (!permissions || !Array.isArray(permissions)) {
    return {};
  }

  const result = {};

  permissions.forEach((permission) => {
    if (permission.path) {
      result[permission.path] = true;
    }
  });

  return result;
}
